import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSmartListAdd = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 19"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M13.616 14.5v2.116a.37.37 0 0 0 .115.269.372.372 0 0 0 .539 0 .36.36 0 0 0 .114-.27V14.5H16.5a.37.37 0 0 0 .27-.115.373.373 0 0 0-.001-.539.37.37 0 0 0-.269-.115h-2.116v-2.116a.37.37 0 0 0-.115-.269.372.372 0 0 0-.539 0 .36.36 0 0 0-.114.27v2.115H11.5a.37.37 0 0 0-.27.115.373.373 0 0 0 .001.539.37.37 0 0 0 .269.115zm-12 1.5q-.667 0-1.141-.475A1.56 1.56 0 0 1 0 14.386V1.615Q0 .949.475.475A1.56 1.56 0 0 1 1.615 0h12.77q.666 0 1.14.475.474.476.475 1.14v5.116q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.49.49 0 0 1-.143-.356V1.616a.6.6 0 0 0-.192-.424.58.58 0 0 0-.424-.192H1.616a.6.6 0 0 0-.424.192.58.58 0 0 0-.192.424v12.769a.6.6 0 0 0 .192.423.58.58 0 0 0 .423.192h5.116q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356a.49.49 0 0 1-.356.143zM1 14.007V15 1v6.306-.075zm2.5-2.237q0 .212.144.356a.49.49 0 0 0 .356.143h2.96q.212 0 .356-.144a.48.48 0 0 0 .143-.356.49.49 0 0 0-.5-.5H4a.48.48 0 0 0-.356.144.49.49 0 0 0-.144.357M3.5 8q0 .215.144.357A.49.49 0 0 0 4 8.5h6.48a.49.49 0 0 0 .357-.144.49.49 0 0 0 .144-.357.48.48 0 0 0-.144-.356.49.49 0 0 0-.356-.143H4a.49.49 0 0 0-.5.501m0-3.77a.485.485 0 0 0 .5.499h8q.213 0 .356-.144a.49.49 0 0 0 .144-.357.48.48 0 0 0-.144-.356.48.48 0 0 0-.356-.142H4a.49.49 0 0 0-.5.501M14 18.116q-1.671 0-2.835-1.165Q10 15.787 10 14.116t1.165-2.836T14 10.116t2.836 1.164T18 14.116q0 1.67-1.164 2.835Q15.67 18.116 14 18.116"
    />
  </svg>
)
export default SvgSmartListAdd
